// src/pages/Modules/PartnershipModule.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Grid, CardActionArea, CircularProgress } from '@mui/material';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { usePermissions } from '../../context/PermissionContext';
import BackButton from '../../components/BackButton';

const cardOptions = [
  {
    title: 'JOIN-US Request',
    icon: <GroupAddIcon sx={{ fontSize: 50, color: 'primary.main' }} />,
    path: '/partnership/join-us-request',
    perm: 'partnership.joinUs',
    description: 'View and complete Join Us Service Requests from customers'
  }
];

const PartnershipModule = () => {
  const { can, loading } = usePermissions();
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', padding: 3 }}>
      <BackButton />
      <br /><br />
      <Box sx={{ width: '100%', p: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <HandshakeIcon fontSize="large" color="primary" />
          PARTNERSHIP MODULE
        </Typography>

        <Grid container spacing={3}>
          {cardOptions.map((option) => {
            const isAccessible = can(option.perm);
            if (!isAccessible) return null;

            return (
              <Grid item xs={12} sm={6} md={4} key={option.title}>
                <Card 
                  elevation={3}
                  sx={{ 
                    height: '100%', 
                    borderRadius: 3,
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6
                    }
                  }}
                >
                  <CardActionArea 
                    onClick={() => handleCardClick(option.path)}
                    sx={{ height: '100%', p: 2 }}
                  >
                    <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ mb: 2 }}>
                        {option.icon}
                      </Box>
                      <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {option.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {option.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default PartnershipModule;
